import { render, staticRenderFns } from "./Layout2.vue?vue&type=template&id=dbf6af4a&scoped=true"
import script from "./Layout2.vue?vue&type=script&lang=js"
export * from "./Layout2.vue?vue&type=script&lang=js"
import style0 from "./Layout2.vue?vue&type=style&index=0&id=dbf6af4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf6af4a",
  null
  
)

export default component.exports